export default function strictOnce(action) {
  let called = false
  return strictOnce_wrapper

  function strictOnce_wrapper() {
    if (called) {
      throw new Error('strictOnce: action has been called already!')
    }

    called = true
    return action.apply(null, arguments)
  }
}
